import * as React from "react";
import * as style from "./page.module.scss";
import Seo from "components/Seo";

const Page = ({ seoTitle, seoDescription, seoImage, children, location, state }) => {
  return (
    <div className={style.Page}>
      <Seo title={seoTitle} description={seoDescription} image={seoImage} />
      {children}
    </div>
  );
};

export default Page;
